/**
 * Extracts individual bitwise flag values from a combined bitwise value.
 * Used to determine which specific flags are set in a bitwise combination.
 *
 * @param {number} applyRatesToValue - The combined bitwise value to decompose
 * @param {Array<{key: number}>} applyRatesToConstants - Array of objects containing bitwise flag constants
 * @returns {Array<number>} Array of individual flag values that are set in the combined value
 *
 * @example
 * // If applyRatesToValue = 5 (binary: 101) and constants = [{key: 1}, {key: 4}, {key: 8}]
 * // Returns [1, 4] because both flags 1 and 4 are set in value 5
 */
export function ReverseBitwise(applyRatesToValue, applyRatesToConstants) {
    const results = [];
    applyRatesToConstants.forEach((element) => {
        // eslint-disable-next-line no-bitwise
        if (element.key & applyRatesToValue)
            results.push(element.key);
    });
    return results;
}

/**
 * Calculates the combined bitwise value from an array of field objects.
 * Sums up the key values of all checked fields to create a single bitwise flag.
 *
 * @param {Array<{checked: boolean, key: number}>} requiredFieldsArray - Array of field objects with checked status and bitwise key
 * @returns {number} Combined bitwise value representing all checked fields
 *
 * @example
 * // If requiredFieldsArray = [{checked: true, key: 1}, {checked: false, key: 2}, {checked: true, key: 4}]
 * // Returns 5 (1 + 4) because only fields with keys 1 and 4 are checked
 */
export function GetBitwiseFlagsValue(requiredFieldsArray) {
    return requiredFieldsArray.filter((field) => field.checked).reduce((sum, field) => sum + field.key, 0);
}
